import { render, staticRenderFns } from "./UploadFlag.vue?vue&type=template&id=3c712170&scoped=true&"
import script from "./UploadFlag.vue?vue&type=script&lang=js&"
export * from "./UploadFlag.vue?vue&type=script&lang=js&"
import style0 from "./UploadFlag.vue?vue&type=style&index=0&id=3c712170&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c712170",
  null
  
)

export default component.exports